import { Injectable } from '@angular/core';

export interface NavigatorPermissionResult {
  supported: boolean;
  status?: PermissionStatus;
}

@Injectable({
  providedIn: 'root'
})
export class NavigatorService {

  public get isNavigatorAvailable(): boolean {
    return (typeof navigator !== 'undefined');
  }

  public get hasPermissionsApi(): boolean {
    if (!this.isNavigatorAvailable) {
      return false;
    }
    const permissionsApi: Permissions | undefined = navigator.permissions;
    if (!permissionsApi) {
      console.warn('API Permissions is not supported');
    }
    const queryMethod = permissionsApi?.query;
    if (typeof queryMethod !== 'function') {
      console.warn('Navigator permissions API query method is not a function');
      return false;
    }
    return Boolean(permissionsApi && (typeof queryMethod === 'function'));
  }

  public async getPermissionStatus(name: string): Promise<NavigatorPermissionResult> {
    if (!this.hasPermissionsApi) {
      return {supported: false};
    }

    const permissionsApi: Permissions | undefined = navigator.permissions;
    const queryMethod: unknown = permissionsApi?.query;
    if (typeof queryMethod !== 'function') {
      return {supported: false};
    }

    try {
      const status: unknown = await Reflect.apply(queryMethod, permissionsApi, [{name}]);
      if (!this.isPermissionStatus(status)) {
        return {supported: false};
      }
      return {supported: true, status};
    } catch (error) {
      console.warn(`Permission "${name}" is not supported:`, error);
      return {supported: false};
    }
  }

  private isPermissionStatus(value: unknown): value is PermissionStatus {
    if (!value || typeof value !== 'object') return false;
    if (!Reflect.has(value, 'state')) return false;

    const state: unknown = Reflect.get(value, 'state');
    return state === 'granted' || state === 'denied' || state === 'prompt';
  }
}
